import ApiService from "@/common/login.service";

export default {
  addUser() {
    return ApiService.post("logins/add-user");
  },
  attemptLogin(session_id, sCode) {
    return ApiService.post("logins/attempt-login", {
      session_id: session_id,
      sCode: sCode
    });
  }
};
